module.exports = __webpack_public_path__ + "media/fonts/suisse-works/SuisseWorks-Regular-5078b59461c2bc8bacdd0280548116ad.ttf";